import React from 'react';
import { Trail } from '../../models/Trail';
import ShowSingleTrail from './ShowSingleTrail';

type TrailMarkersProps = {
	trail: Trail;
};

// @ts-ignore

const SingleTrailMarker: React.FC<TrailMarkersProps> = ({
	trail,
}: TrailMarkersProps) => {
	return <ShowSingleTrail key={`map-trails-${trail.id}`} trail={trail} />;
};

export default SingleTrailMarker;
